---
date: 2022-06-24
title: Status website
---

Visit [status.indoorequal.org](https://status.indoorequal.org/) to view the current status of indoor= services.
